import cn from 'classnames';
// Helpers
import { slugify } from 'helpers/string';
import { withCDN } from 'helpers/cdn';
// Ui
import Image from 'ui/Image/Image';
// Styles
import styles from './TrustBadges.module.scss';

type TrustBadgesProps = {
  showShipping?: boolean;
  showMemorabilia?: boolean;
  /** When true, hides description text and applies compact badge-only styling (e.g. for inside accordions). Default false. */
  iconsOnly?: boolean;
  className?: string;
};

const TrustBadges = ({
  showMemorabilia,
  showShipping,
  iconsOnly = false,
  className,
}: TrustBadgesProps) => {
  const badges = [
    ...(showShipping
      ? [
          {
            url: withCDN('/images/trust-badges/fast-shipping.png'),
            description: 'International Shipping',
          },
        ]
      : []),
    {
      url: withCDN('/images/trust-badges/secure-checkout.png'),
      description: 'Safe and Secure Checkout',
    },
    {
      url: withCDN('/images/trust-badges/customer-satisfaction.png'),
      description: 'Customer Satisfaction Guaranteed',
    },
    ...(showMemorabilia
      ? [
          {
            url: withCDN('/images/trust-badges/memorabilia-certified.png'),
            description: 'Certified Authentic Memorabilia',
          },
        ]
      : []),
  ];

  return (
    <div
      className={cn(styles.root, className, {
        [styles.iconsOnly]: iconsOnly,
      })}
    >
      {badges.map((badge) => (
        <div key={slugify(badge.description)} className={styles.badge}>
          <Image
            src={badge.url}
            alt={badge.description}
            className={styles.image}
            sizes="10vw"
          />

          {!iconsOnly && (
            <p className={styles.description}>{badge.description}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
